<template>
  <Content @back="$router.push('/home')">
    <template v-slot:nav_left>
      <div style="display: flex;align-items: center" class="mediaTitleList">
<!--        <div-->
<!--          v-for="(nav, index) in navTitle"-->
<!--          :key="index"-->
<!--          :class="idx === index ? 'active' : ''"-->
<!--          style="cursor: pointer;padding:10px 20px;"-->
<!--          @click="changeNav(index)">-->
<!--          {{nav}}-->
<!--        </div>-->
        教练员帐号开通
      </div>
    </template>
    <template v-slot:nav_right>
      <!--      <div v-if="idx === 0" class="yioks_btn" @click="addPay=true">-->
      <!--        购买教练员数量-->
      <!--      </div>-->
      <!--      <div v-else class="yioks_btn" @click="addRenewToYouth=true">-->
      <!--        续费教练员数量-->
      <!--      </div>-->
      <div v-if="userRole === 'system'" class="yioks_btn" @click="addRenewToSystem=true">
        开通教练员
      </div>
      <div v-if="userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club'" class="yioks_btn" @click="addRenewToYouth=true">
        开通教练员
      </div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <select v-model="selectVal.organUuid" class="yioks_select" @change="changeSelectOrg" >
            <option v-if="selectOrganList.length > 1" value=''>全部区体育行政部门</option>
            <option
              v-for="item in selectOrganList"
              :key="item.organUuid"
              :value="item.organUuid"
            >{{ item.organShortName }}</option>
          </select>
          <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeQuery(true)" >
            <option v-if="selectCenterList.length !== 1" value=''>全部培训机构</option>
            <option
              v-for="item in selectCenterList"
              :key="item.uuid"
              :value="item.uuid"
            >{{ item.youthShortName }}</option>
          </select>
          <select
            v-model="selectVal.orderStatus"
            class="yioks_select"
            @change="changeQuery(true)"
          >
            <option value="">请选择订单状态</option>
            <option value="UNPAID">待付款</option>
            <option value="DURING">支付中</option>
            <option value="PAID">已付款</option>
            <option value="COMPLETE">已完成</option>
          </select>
        </div>
<!--        <div class="search_box">-->
<!--          <input-->
<!--            v-model.trim="selectVal.keyWord"-->
<!--            type="text"-->
<!--            class="yioks_input"-->
<!--            placeholder="请输入关键词"-->
<!--            @keyup.enter="changeQuery(true)"-->
<!--          >-->
<!--          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>-->
<!--        </div>-->
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div style="position: absolute;margin-left: 40px;margin-top: -20px;font-weight: bold;color: red;font-size: 15px;">
            <span>如希望批量支付，请联系平台下方客服微信，确认需要开通账户的教练员姓名，我们为您合并订单后，可一次性完成支付。</span>
          </div>
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th payToCoachNum2"><strong>开通数量</strong></div>
              <template v-if="userRole === 'system' || userRole === 'admin'">
                <div class="th youthShortName"><strong>单位</strong></div>
              </template>
              <div class="th" :class="userRole === 'system' || userRole === 'admin' ? 'coachName' : 'coachName2'">
                <strong>教练员名称</strong>
              </div>
              <div class="th renewToCoachLimit"><strong>使用年份</strong></div>
              <div class="th orderStatus"><strong>订单状态</strong></div>
              <div class="th payablePrice"><strong>支付金额</strong></div>
              <div class="th completeAt"><strong>付费日期</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll >
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    v-for="(item, index) in payList"
                    :key="index"
                    class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td payToCoachNum2">
                      <p>{{ item.payToCoachNum || '--' }}个</p>
                    </div>
                    <template v-if="userRole === 'system' || userRole === 'admin'">
                      <div class="td youthShortName" :title="`${item.organShortName}-${item.youthShortName}`">
                        <p>{{ item.youthShortName || '--' }}</p>
                      </div>
                    </template>
                    <div class="td"  :class="userRole === 'system' || userRole === 'admin' ? 'coachName' : 'coachName2'" :title="item.coachName">
                      <p>{{item.coachName}}</p>
                    </div>
                    <div class="td renewToCoachLimit">
                      <p>{{item.renewToCoachLimit}}年</p>
                    </div>
                    <div class="td orderStatus">
                      <p>{{item.orderStatus | orderStatus}}</p>
                    </div>
                    <div class="td payablePrice">
                      <p>￥{{item.payablePrice | orderPrice}}</p>
                    </div>
                    <template v-if="item.completeAt">
                      <div class="td completeAt" :title="item.completeAt | time">
                        <p>{{item.completeAt | time}}</p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="td completeAt">
                        <p>--</p>
                      </div>
                    </template>
                    <div class="td opt">
                      <template v-if="userRole === 'system' || userRole === 'admin'">
                        <p style="color:#f88594" v-if="!item.paid"><span>未支付</span></p>
                        <p v-else><span>已支付</span></p>
                      </template>
                      <template v-else>
                        <p v-if="!item.paid">
                          <span class="item" @click="goDetail(item.orderUuid)">支付</span>
                        </p>
                        <p v-else>
                          <span>已支付</span>
                        </p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading"/>
        <template v-if="userRole === 'system'">
          <yioks-empty v-if="empty" tips="暂时没有数据，" name="立即开通教练员帐号" @callback="addRenewToSystem = true"></yioks-empty>
        </template>
        <template v-if="userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club'">
          <yioks-empty v-if="empty" tips="暂时没有数据，" name="立即开通教练员帐号" @callback="addRenewToYouth = true"></yioks-empty>
        </template>
<!--        <template v-if="idx === 0">-->
<!--          <yioks-empty v-if="empty" tips="暂时没有数据，" name="立即购买教练员数量" @callback="addPay = true"></yioks-empty>-->
<!--        </template>-->
<!--        <template v-else>-->
<!--          <yioks-empty v-if="empty" tips="暂时没有数据，" name="立即续费教练员数量" @callback="addRenewToYouth = true"></yioks-empty>-->
<!--        </template>-->

      </div>
      <Pagination :total="total" :page.sync="page" />
<!--      <template v-if="addPay">-->
<!--        <AddPayDialog-->
<!--          :addSquad.sync="addPay"-->
<!--          :organList="organList"-->
<!--          @hideAddPayDialog="hideAddPayDialog" ></AddPayDialog>-->
<!--      </template>-->
      <template v-if="addRenewToSystem">
        <AddRenewToSystemDialog
          :addSquad.sync="addRenewToSystem"
          @hideAddRenewDialog="hideAddRenewToSystemDialog" ></AddRenewToSystemDialog>
      </template>
      <template v-if="addRenewToYouth">
        <AddRenewToYouthDialog
          :addSquad.sync="addRenewToYouth"
          @hideAddRenewDialog="hideAddRenewToYouthDialog" ></AddRenewToYouthDialog>
      </template>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/regular/trash-alt'
import 'vue-awesome/icons/regular/edit'
import pay from '@/api/pay'
import coach from '@/api/coach'
import storage from '@/utils/storage'
import squadFormRule from '@/utils/formRules/squad'
import { ops } from '@/utils/scrollIndialog'
import { orderStatus,orderPrice }from "@/assets/js/pay"
export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddPayDialog': () => import('@/components/pay'),
    'AddRenewToSystemDialog': () => import('@/components/pay/coachRenew'),
    'AddRenewToYouthDialog': () => import('@/components/pay/coachRenewToYouth')
  },
  filters: {
    orderStatus,
    orderPrice
  },
  mixins: [squadFormRule],
  data () {
    return {
      ops,
//      navTitle: ['教练员购买列表', '教练员续费列表'],
//      idx: Number(this.$route.query.idx) || 0,
//      addPay: false,
      addRenewToSystem: false,
      addRenewToYouth: false,
      payList: [],
      addbtnLoading: false,
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      total: 0,
      pageSize: 20,
      page: 0,
      empty: false,
      showList: false,
      showTip: false,
      loading: true,
      centerList: [],
      organList: [],
      selectCenterList: [],
      selectOrganList: [],
      selectVal: {
        organUuid: '',
        youthUuid: '',
        orderStatus:''
      },
    }
  },
  watch: {
    page () {
      this.changeQuery()
    }

  },
  created () {
    const { page, orderStatus, organUuid, youthUuid } = this.$route.query;
    page && (this.page = Number(page));
    orderStatus && (this.$set(this.selectVal, 'orderStatus', orderStatus));
    organUuid && (this.$set(this.selectVal, 'organUuid', organUuid));
    youthUuid && (this.$set(this.selectVal, 'youthUuid', youthUuid));
    this.getOrganListAndCenterList();
    this.getPayList();
    this.getRenewYouthNum(); // 获取俱乐部开通教练员数量
  },
  methods: {
//    changeNav (index) {
//      if (this.idx === index) return;
//      this.page = 0;
//      this.total = 0;
//      this.idx = index;
//      this.changeQuery(true)
//    },
    getPayList () {
      this.loading = true;
      this.empty = false;
      this.showList = false;
      let request;
//      if (this.idx === 0) { // 教练员购买列表
//        if (this.userRole === 'system' || this.userRole === 'admin') {
//          request = pay.getOrderSystemPage
//        } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
//          request = pay.getOrderYouthPage
//        }
//      }else{
//      }
      // 教练员续费列表
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = pay.getRenewSystemPage
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = pay.getRenewYouthPage
      }
      request({ page: this.page, size: this.pageSize, orderStatus: this.selectVal.orderStatus, organUuid: this.selectVal.organUuid, youthUuid: this.selectVal.youthUuid }).then((res) => {
        this.loading = false;
        this.total = res.totalElements;
        if (res.content.length) {
          this.payList = res.content;
          // 循环获取教练名称
          this.payList.map(item=>{
            if(item.payToCoachType === 'renew'){
              let name = "";
              item.payToCoachRenewList.map(val=>{
                name = name+val.idName+" "
              });
              item.coachName = name;
            }
          });
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false;
        console.error(err)
      })
    },
    goDetail (uuid) {
//      if(this.idx === 0){
//        this.$router.push({
//          path: 'detail',
//          query: {
//            uuid
//          }
//        })
//      }else{
//      }
      this.$router.push({
        path: 'renewDetail',
        query: {
          uuid
        }
      })
    },
//    hideAddPayDialog (flag) {
//      this.addPay = flag;
//      this.getPayList()
//    },
    hideAddRenewToSystemDialog (flag) {
      this.addRenewToSystem = flag;
      this.getPayList()
    },
    hideAddRenewToYouthDialog (flag) {
      this.addRenewToYouth = flag;
      this.getPayList()
    },
    getOrganListAndCenterList () {
      let data = this.uuid;
      let request;
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = coach.getCenterListBySystem;
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      }
      request(data).then((res) => {
        this.organList = res;
        this.selectOrganList = res;
        if (this.organList.length === 1) {
          this.$set(this.selectVal, 'organUuid', this.organList[0].organUuid);
          this.selectCenterList = this.selectOrganList.find(item => {
            return item.organUuid === this.selectVal.organUuid
          }).youthList || [];
          if (this.selectCenterList.length === 1) {
            this.$set(this.selectVal, 'youthUuid', this.selectCenterList[0].uuid)
          }
        }
        this.selectVal.organUuid && this.setCenterList()
      });
    },
    setCenterList () {
      this.selectCenterList = this.selectOrganList.find(item => {
        return item.organUuid === this.selectVal.organUuid
      }).youthList || [];
      this.centerList = this.selectCenterList
    },
    changeQuery (flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          orderStatus: this.selectVal.orderStatus,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
//          idx: this.idx
        }
      })
      this.getPayList()
    },
    changeSelectOrg () {
      this.$set(this.selectVal, 'youthUuid', '');
      if (this.selectVal.organUuid) {
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.selectVal.organUuid
        }).youthList || [];
        if (this.selectCenterList.length === 1) {
          this.$set(this.selectVal, 'youthUuid', this.selectCenterList[0].uuid)
        }
      } else {
        this.selectCenterList = [];
        this.$set(this.selectVal, 'youthUuid', '')
      }
      this.changeQuery(true)
    },
    // 获取俱乐部开通教练员数量
    getRenewYouthNum() {
      if(this.userRole === 'youth' || this.userRole === 'club'){
        pay.getRenewYouthNum().then((res) => {
          storage.set('renewYouthNum', Number(res)||0);
          this.$store.commit("setRenewYouthNum");
        });
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
  .mediaTitleList
    .active
      background-color #4cd964
  @import '~@/assets/css/variable'
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom 15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq {
        width 6%
      }
      .payToCoachNum{
        width 12%
      }
      .payToCoachNum2{
        width 10%
      }
      .youthShortName{
        width 15%
      }
      .orderStatus{
        width: 12%;
      }
      .payablePrice{
        width 10%
      }
      .completeAt{
        width 12%
      }
      .coachName{
        width 18%
      }
      .coachName2{
        width 31%
      }
      .renewToCoachLimit{
        width 10%
      }
      .opt{
        width: 9%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
    }
  .demo-ruleForm
    height 475px
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>

